import iconOne from '../../assets/features/1.png';
import iconTwo from '../../assets/features/2.png';
import iconThree from '../../assets/features/3.png';
import iconFour from '../../assets/features/4.png';

const featuresData = [
    {
        'icon': iconOne,
        'title': 'Safety first',
        'description': 'We prioritize safety with health checks and more'
    },
    {
    'icon': iconTwo,
    'title': 'Affordable Pricing',
    'description': 'We provide transparent and accessible pricing for all.'
    },
    {
        'icon': iconThree,
        'title': 'Full-service dentistry',
        'description': 'Our clinic offer a full  of dental service, from exams to implants and veneers.'
    },
    {
    'icon': iconFour,
    'title': 'Compassionate Care',
    'description': 'We ensure comfort and understanding for every patient.'
    },


]

export default featuresData;